import React from 'react';
import {withRouter} from "components/router/withRouter";
import NewPreApproval from "components/preapproval/NewPreApproval.component.tsx";

function PreApproval(props) {
    return <NewPreApproval {...props}/>;
}

export default withRouter(PreApproval);